// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__2zB55","hide":"styles_hide__2jyzG","circle":"styles_circle__2nq4f","loader":"styles_loader__1WzxT","placeholder":"styles_placeholder__8fV43"};